<template>
  <div class="main-box detail-view" v-if="!property">
    <b-alert variant="warning" show class="my-0" >
      Sie haben keinen Zugriff
    </b-alert>
  </div>
  <b-overlay :show="showOverlay" rounded="sm" v-else>
    <div class="main-box detail-view">
      <h1>Gebäudedetail</h1>
      <div class="my-2">
        <b-button to="/gebaeude">Zurück</b-button>
      </div>
      <b-alert v-model="hasError" variant="warning">
        {{ errorMessage }}
      </b-alert>
      <b-table class="detail-view" :fields="fields" :items="[property]" stacked>
        <template v-slot:empty>
          <h4>Keine Einträge</h4>
        </template>
        <template v-slot:cell(strasse)="row">
          <span>{{ row.item.strasse }} {{ row.item.hausNr }}</span>
        </template>
        <template v-slot:cell(plz)="row">
          <span>{{ row.item.plz }} {{ row.item.ort }}</span>
        </template>
        <template v-slot:cell(denkmalgeschuetzt)="row">
          <span>{{ row.item.denkmalgeschuetzt ? 'Ja' : 'Nein' }}</span>
        </template>
        <template v-slot:cell(energiebezugsflaeche)="row">
          <span>{{ row.item.energiebezugsflaeche | formatNumber }} m²</span>
        </template>
      </b-table>
      <div class="my-2">
        <b-button :to="`/gebaeude/${this.$route.params.propertyId}/bearbeiten`" variant="primary">
          Bearbeiten
        </b-button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasError: false,
      errorMessage: '',
      fields: [
        { key: 'strasse', label: 'Strasse/Nr' },
        { key: 'plz', label: 'PLZ/Ort' },
        { key: 'egid', label: 'EGID' },
        { key: 'versicherungsNr', label: 'Gebäude-Versicherungs-Nr.' },
        { key: 'parzellenNr', label: 'Parzellen-Nr.' },
        { key: 'gebaeudeartBezeichnung', label: 'Gebäudeart' },
        { key: 'nutzungsartBezeichnung', label: 'Nutzungsart' },
        { key: 'baujahr' },
        { key: 'anzahlWohnungen' },
        { key: 'denkmalgeschuetzt', label: 'Denkmalgeschützt' },
        { key: 'energiebezugsflaeche', label: 'Energiebezugsfläche' },
        { key: 'hauptwaermeerzeugungBestehendBezeichnung', label: 'Hauptwärmeerzeugung bestehend (Typ)' },
        { key: 'hauptwaermeerzeugungNeuBezeichnung', label: 'Hautpwärmeerzeugung nach Massnahme' }
      ],
      showOverlay: true
    }),
    created () {
      const { propertyId } = this.$route.params
      this.getProperty(propertyId)
    },
    methods: {
      getProperty (propertyId) {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('property/GET_PROPERTY_BY_ID', { propertyId, includeOrganisation: false }).then(res => {
          const { data, errors } = res

          if (errors) {
            this.showOverlay = false
            return errorHandler(this, errors)
          }

          const { gemeindeId: communityId } = data.liegenschaftById

          if (!communityId) {
            this.hasError = true
            this.errorMessage = 'Für das Gebäude wurde keine St.Galler Gemeinde erkannt'
          }
          this.showOverlay = false
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      ...mapGetters({ property: 'property/PROPERTY' })
    }
  }
</script>

<style lang="scss">
  .detail-view .table.b-table.b-table-stacked > tbody > tr > [data-label]::before{
     text-align: left !important;
   }
</style>
